import HBIcon from "@/components/HBIcon";
import { SHORTCUT } from "@/constants/shortcut";
import { button_click } from "@/tracker/collecter/buttonClick";
import { getNextViewImageSetp } from "@/utils/getHistorySetp";
import isEditingElement from "@/utils/isEditingElement";
import { useKeyPress } from "ahooks";
import classNames from "classnames";
import qs from "qs";
import { useRef } from "react";
import { When } from "react-if";
import styles from "./index.module.less";

export default function ModalOperate(props) {
  const {
    onClose,
    onOperation,
    nextPin,
    prevPin,
    top,
    isNewRecommend,
    hideNavButtons,
    ...rest
  } = props;
  // 快捷键：上一个采集
  useKeyPress(
    SHORTCUT.PREV_PIN,
    () => {
      const editing = isEditingElement();
      const { modalImg } = qs.parse(location.search.slice(1));
      if (editing) {
        return false;
      }
      if (prevPin) {
        button_click(prevBtnRef.current, {
          other: {
            button_name: "快捷键上一张",
            module_name: modalImg ? "查看大图" : "采集详情",
            reset_mn: true,
          },
        });
        onOperation(prevPin);
      }
    },
    {
      exactMatch: true,
    }
  );

  // 快捷键：下一个采集
  useKeyPress(
    SHORTCUT.NEXT_PIN,
    () => {
      const editing = isEditingElement();
      const { modalImg } = qs.parse(location.search.slice(1));
      if (editing) {
        return false;
      }

      if (nextPin) {
        button_click(nextBtnRef.current, {
          other: {
            button_name: "快捷键下一张",
            module_name: modalImg ? "查看大图" : "采集详情",
            reset_mn: true,
          },
        });
        onOperation(nextPin);
      }
    },
    {
      exactMatch: true,
    }
  );

  const closeBtnRef = useRef<HTMLAnchorElement>(null);
  const nextBtnRef = useRef<HTMLAnchorElement>(null);
  const prevBtnRef = useRef<HTMLAnchorElement>(null);

  // 监听esc退出详情页操作，上报埋点
  useKeyPress(SHORTCUT.EXIT, () => {
    button_click(closeBtnRef.current, {
      other: {
        button_name: "快捷键关闭详情页",
      },
    });
  });

  const goPrePin = () => {
    let setp = getNextViewImageSetp();
    history.go(-1 * setp);
  };
  return (
    <div className={styles.operate} {...rest}>
      <div
        className={styles.mask}
        onClick={onClose}
        data-gd-click="button_click"
        data-button-name="空白区域关闭"
      ></div>
      <a
        className={classNames(styles.close, {
          [styles.newStyle]: isNewRecommend,
        })}
        ref={closeBtnRef}
        onClick={onClose}
        data-tooltip="关闭 [ESC]"
        data-tooltip-position="bottom"
        data-gd-click="button_click"
        data-button-name="关闭详情页"
      >
        <HBIcon type="ic_close" />
      </a>
      <a
        className={classNames(styles.backBtn, {
          [styles.newStyle]: isNewRecommend,
        })}
        onClick={goPrePin}
        data-gd-click="button_click"
        data-button-name="返回上一页"
        ref={prevBtnRef}
      >
        <HBIcon type="ic_arrowThinLeft" />
        <span className={styles.backDesc}>返回</span>
      </a>
      <div className={styles.operation}>
        <When condition={nextPin && !hideNavButtons}>
          <a
            className={styles.next}
            title="下一张"
            onClick={() => onOperation(nextPin)}
            style={{ top }}
            data-gd-click="button_click"
            data-button-name="下一张"
            ref={nextBtnRef}
          >
            <HBIcon type="ic_chevron_right" />
          </a>
        </When>
        <When condition={prevPin && !hideNavButtons}>
          <a
            className={styles.prev}
            title="上一张"
            onClick={() => onOperation(prevPin)}
            style={{ top }}
            data-gd-click="button_click"
            data-button-name="上一张"
            ref={prevBtnRef}
          >
            <HBIcon type="ic_chevron_left" />
          </a>
        </When>
      </div>
    </div>
  );
}
